<template>
  <div class="v2-our-advantages">
    <h2 class="mb-3 mb-md-4">
      {{ t("Real people, real pleasure, filmed by women") }}
    </h2>
    <div class="advantages-container rounded-1">
      <div class="row">
        <div class="col-lg-8">
          <div class="badges-container">
            <h3 class="text-center text-lg-start">
              {{ t("Join Ersties & get all this and more") }}
            </h3>
            <div class="image-border mb-3 pe-0 d-lg-none">
              <img v-lazy="yoniImage" class="w-100 d-lg-none rounded-1 pe-0" :alt="`image border`" />
            </div>
            <div class="d-flex flex-wrap mt-3 mt-md-4">
              <div class="row">
                <div v-for="(advantage, i) in advantages" :key="i" class="col-12 col-md-6 advantage">
                  <badge :icon="advantage.icon" />
                  <badge-description :description="advantage.description" :title="advantage.title" />
                </div>
              </div>
            </div>
            <button v-modal.modal-signup class="btn btn-primary border-dark d-block d-lg-inline m-auto wide" @click="sendRegistrationTrack">
              {{ t("Join Ersties") }}
            </button>
          </div>
        </div>
        <lazy-component class="col-lg-4 ms-auto d-none d-lg-flex">
          <div class="cover rounded-1 h-100" />
        </lazy-component>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import BadgeDescription from "@/components/v2/badge-description/index.vue";
import Badge from "@/components/v2/badge/index.vue";
import { amplitudeRegistrationButtonClickTrack } from "@/utils/amplitude";
import yoniImage from "@/assets/v2/images/home/yoni.jpg";

defineOptions({
  name: "our-advantages",
});

const { t } = useI18n();

const advantages = computed(() => [
  {
    icon: "film-strip",
    title: t("Fantasies come to life"),
    description: t("& real orgasms, filmed by women"),
  },
  {
    icon: "gift",
    title: t("6X uploads p/w"),
    description: t("quickies, orgies & specials"),
  },
  {
    icon: "download",
    title: t("Interactive Liveshows"),
    description: t("plus model interviews, vlogs, cams & more"),
  },
  {
    icon: "flower",
    title: t("Member Specials!"),
    description: t("vote on shoots, for your favourite models & join live shows"),
  },
]);

const sendRegistrationTrack = () => {
  amplitudeRegistrationButtonClickTrack("join ersties");
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
